import { useEffect,useState } from 'react'
import { Syllabus } from '../../../../types/dataModel';
import {API} from '../../../../common/Constants'
import useFetch from '../../../../hooks/useFetch';
import PreLoader from '../../../../core/common/preLoader';
import { getAPIHeaders } from '../../../../common/Utils';
import { Link } from 'react-router-dom'

interface Props {
  onSuccess: (value: string)=> void
  title: string
}


const EditSection = ({onSuccess, title}:Props) => {
  const [section, setSection] = useState<string>(title)
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");
  const [showMsgBox, setShowMsgBox] = useState<boolean>(false)

  useEffect(()=>{
    setSection(title)
  },[title])

  const handleSubmit = (event:any) => {
      event.preventDefault()

      if(!section){
        setErrorMessage("Please provide section name")
      }  else {
        setErrorMessage("")
        // setShowMsgBox(true)
        onSuccess(section)
      }
  }

    const reset = () => {
      setSection("")
      setErrorMessage("")
      setShowMsgBox(false)
    }

    const renderForm = () => {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Edit Section</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control"
                        value={section}
                        onChange={(e)=>{
                            setSection(e.target.value)
                        }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ 
                justifyContent: "space-between",
                flexDirection:'row'}}>
                <div style={{maxWidth:"50%"}}>
                        { errorMessage  ?
                          <>
                            <i className="ti ti-alert-triangle text-danger" />  
                            <span className='text-danger'> {errorMessage} </span> 
                          </> 
                          : <></>
                        }
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={reset}
                  >
                    Cancel
                  </button>
                  <button type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleSubmit}>
                    Save
                  </button>
              </div>
            </div>
          </form>
        </div>
      )
    }

    const renderMsgBox = () => {
      return (          
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  <i className="ti ti-thumb-up fs-36" />
              </span>
              <h4 className="mb-1">Edit Section Successfull</h4>
              <p className="mb-3">
                  Section is edited successfully.
              </p>
              <div className="d-flex justify-content-center">
                  <Link to="#" 
                      data-bs-dismiss="modal" 
                      className="btn btn-success"
                      onClick={()=>{
                        setTimeout(() => {
                          setShowMsgBox(false);
                        }, 1000);
                        }}>
                      Close
                  </Link>
              </div>
          </div>
      </div>
    </div>)
    }

    return (
      <div className="modal fade" id="edit_section"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered modal-md">
          {showMsgBox ? renderMsgBox() : renderForm()}
        </div>
      </div>
    )
}

export default EditSection